import { z } from 'zod'

export interface NetworkError {
  result?: {
    errors?: Array<{ message: string }>
  }
}

export const isNetworkError = (error: unknown): error is NetworkError => {
  return error !== null && typeof error === 'object'
}

export interface A3InnuvaMapping {
  factorial_id: string
  a3innuva_id: string
  meta?: { [key: string]: string }
}

export interface A3InnunvaSource {
  source?: string
  mappings?: A3InnuvaMapping[]
}

export interface A3InnuvaWizardData {
  questions: { [key: string]: string }
  answers: { [key: string]: string }
  sources?: { [key: string]: A3InnunvaSource }
  loginStatus?: boolean
}

// eslint-disable-next-line factorial/no-unhealthy-enums
export enum A3InnuvaWorkplaceSource {
  workplace = 'workplace',
  legal_entity = 'legal_entity',
  employee_group = 'employee_group',
}

// eslint-disable-next-line factorial/no-unhealthy-enums
export enum ExportFormat {
  A3INNUVA_SUPPLEMENTS = 'a3innuva_supplements',
}

export const a3InnuvaSourceSchema = z.object({
  source: z.string().optional(),
  mappings: z
    .array(
      z.object({
        factorial_id: z.union([z.string(), z.number()]),
        a3innuva_id: z.union([z.string(), z.number()]),
        meta: z
          .object({
            uuid: z.string().optional(),
            legal_entity_id: z.string().optional(),
          })
          .optional(),
      })
    )
    .optional(),
})

export interface PayrollConcept {
  id: number
  label: string
  translatedName?: string | null
  companyId: number
  description: string
  name: string
}
